import { v4 as uuid } from "uuid";
import { ElementState, Preview } from "@creatomate/preview";

const syncMediaElements = async (
  preview: Preview,
  mediaElements: ElementState[],
  propertiesToCopy: Record<string, any>,
  initialTime = 0
): Promise<void> => {
  if (!preview || !preview.state) return undefined;

  const source = preview.getSource();
  const newTrack = Math.max(...preview.state.elements.map((element: any) => element.track)) + 1;

  mediaElements.forEach(async element => {
    const currentTime = initialTime + element.globalTime;
    const id = element.source.id || uuid();
    source.elements.push({
      id,
      track: newTrack,
      ...element.source,
      ...propertiesToCopy,
      time: currentTime
    });
  });

  await preview.setSource(source, false);
  return undefined; // Explicitly return undefined
};

export default syncMediaElements;
